<template>
    <div class="login__form">
        <p class="login__form-text">
            {{ getTranslatedText('Log-in Detaillant') }}
        </p>
        <template v-for="(item, index) in formItem" :key="index">
            <InputCommon :inputItem="item" :isInputDefault="true" nameFunction="on-change-value-login" />
        </template>
    </div>
</template>
<script>
import InputCommon from '@/components/common/input/input.vue';
import languageMixins from '@/mixins/language-mixins';
import EventBus from '@/utils/EventBus';
export default {
    mixins: [languageMixins],
    components: { InputCommon },
    data() {
        return {
            formItem: [
                {
                    label: 'user id',
                    name: 'userId',
                    type: 'text',
                    required: true,
                    isNote: false,
                    noteValue: 'This field is required',
                    icon: 'user',
                    placeholder: 'user id',
                    isCapsLock: true,
                    isNumericPassword: false,
                },
                {
                    label: 'password',
                    name: 'password',
                    type: 'password',
                    required: true,
                    isNote: false,
                    noteValue: 'This field is required',
                    icon: 'password',
                    placeholder: 'password',
                    isNumericPassword: true,
                },
            ],
        };
    },
    created() {
        EventBus.on('show-validate-login', (param) => {
            if (param.type === 'userId') this.formItem[0].isNote = param.isValiabel;
            else this.formItem[1].isNote = param.isValiabel;
        });
    },
    unmounted() {
        EventBus.off('show-validate-login');
    },
    methods: {},
};
</script>
